export interface MissionContext {
  connection?: string;
  commitments?: string[];
  protect?: string;
  capacity?: string;
}
export const MISSION_CONNECTION_MAX = 400;
export const MISSION_COMMITMENT_MAX = 240;
export const MISSION_COMMITMENTS_MAX = 3;
export const MISSION_PROTECT_MAX = 300;
export const MISSION_CAPACITY_MAX = 300;

function field(raw: object, key: string): unknown {
  try { return Reflect.get(raw, key); } catch { return undefined; }
}
function text(raw: unknown, max: number): string | undefined {
  if (typeof raw !== 'string') return undefined;
  const value = raw.trim();
  return value && Array.from(value).length <= max ? value : undefined;
}

/** Comparison input only. Reject malformed fields independently; never shorten a limit. */
export function normalizeMissionContext(raw: unknown): MissionContext {
  if (raw === null || typeof raw !== 'object') return {};
  try { if (Array.isArray(raw)) return {}; } catch { return {}; }
  const result: MissionContext = {};
  const connection = text(field(raw, 'connection'), MISSION_CONNECTION_MAX);
  if (connection) result.connection = connection;
  try {
    const rawItems = field(raw, 'commitments');
    if (Array.isArray(rawItems)) {
      const items: string[] = [];
      for (const rawItem of rawItems) {
        const item = text(rawItem, MISSION_COMMITMENT_MAX);
        if (item && !items.includes(item)) items.push(item);
        if (items.length === MISSION_COMMITMENTS_MAX) break;
      }
      if (items.length) result.commitments = items;
    }
  } catch { /* A broken iteration omits this field, retaining independently valid siblings. */ }
  const protect = text(field(raw, 'protect'), MISSION_PROTECT_MAX);
  if (protect) result.protect = protect;
  const capacity = text(field(raw, 'capacity'), MISSION_CAPACITY_MAX);
  if (capacity) result.capacity = capacity;
  return result;
}
